
import { html, css, LitElement, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { Map, View } from 'ol'
import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile'
import olStylesText from 'ol/ol.css?inline';
import { Style, Icon } from 'ol/style'
import Point from 'ol/geom/Point'
// import { Coordinate } from 'ol/coordinate';
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import { Modify, defaults as defaultInteractions } from 'ol/interaction'
import Feature from 'ol/Feature'
import { fromLonLat, toLonLat } from 'ol/proj'
// import Overlay from 'ol/Overlay';
// import { getWidth } from 'ol/extent';
import FullScreen from 'ol/control/FullScreen'
import { defaults as defaultControls } from 'ol/control/defaults';

export class OSMMap extends LitElement {
    static styles = [
        unsafeCSS(olStylesText),
        css`*, ::after, ::before {
    box-sizing: border-box;
}
:host { display: block; }
.ol-full-screen button {
  cursor: pointer;
}
.map {
  width: 100%;
  height: 500px;
  background: #eee;
  position: relative; /* Essential anchor layer */
}
@media(min-width: 768px) {
    .map {
        height: 640px;
    }
}
`
    ]

    map = null
    markerSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><path fill="red" d="M256 0C160 0 82 78 82 174c0 101 80 164 123 239 42 75 42 102 51 102s9-27 51-99c43-75 123-138 123-239C430 78 352 0 256 0zm0 240c-37 0-67-30-67-67 0-37 30-67 67-67s67 30 67 67c0 37-30 67-37 67z"/><circle cx="256" cy="174" r="67" fill="rgba(0,0,0,0.01)"/></svg>`;
    markerSVGUrl = 'data:image/svg+xml;base64,' + btoa(this.markerSVG);
    markerStyle = new Style({
        image: new Icon({
            anchor: [0.5, 1],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: this.markerSVGUrl,
            scale: 0.1
        }),
    });
    marker = new Feature();
    markerLayer = new VectorLayer({
        source: new VectorSource()
    });

    static get properties() {
        return {
            isLoading: { type: Boolean },
        };
    }

    constructor() {
        super();
        this.isLoading = true;

    }

    getCoords(coords) {
        const lon = parseFloat(this.dataset.lng);
        const lat = parseFloat(this.dataset.lat);

        if (isNaN(lon) || isNaN(lat)) {
            return null
        }
        return fromLonLat([lon, lat]);
    }

    async firstUpdated() {
        const coords = this.getCoords();  
        const zoom = parseFloat(this.dataset.zoom) || 12;
        console.log('Zoom level:', zoom, coords);
        if (coords) {
            const mapContainer = this.shadowRoot.querySelector('.map');
            this.map = new Map({
                target: mapContainer,
                interactions: defaultInteractions({
                    mouseWheelZoom: false
                }),
                controls: defaultControls().extend([
                    new FullScreen()
                ]),
                layers: [
                    new TileLayer({
                        source: new OSM(),
                    }),
                ],
                view: new View({
                    center: coords,
                    zoom: zoom,
                }),
            });
            this.marker = new Feature({
                geometry: new Point(coords),
            })
            this.marker.setStyle(this.markerStyle);
            this.markerLayer.getSource().addFeature(this.marker);
            this.map.addLayer(this.markerLayer)
            this.isLoading = false;
        }
    }

    render() {
        return html`${this.isLoading ? html`` : ''}
           <div class="map" style="${this.isLoading ? 'display: none;' : 'display: block;'}"></div>
           <div id="marker-container" style="display: none;"></div>
        `;
    }
}
customElements.define('osm-map', OSMMap);